import { useMemo } from 'react';
import { useMarketplaceConfig } from '../queries/marketplace';

const CURRENCY_LOCALES_MAP: Record<string, string> = {
  USD: 'en-US',
  EUR: 'de-DE',
  GBP: 'en-GB',
  JPY: 'ja-JP',
  INR: 'hi-IN',
  BDT: 'bn-BD',
  CNY: 'zh-CN',
  RUB: 'ru-RU',
  CAD: 'en-CA',
  AUD: 'en-AU',
};

const getCurrencySymbol = (currency?: string) => {
  if (!currency) return '';
  const locale = CURRENCY_LOCALES_MAP[currency] || 'en-US';

  const parts = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).formatToParts(0);

  const symbolPart = parts.find((part) => part.type === 'currency');

  return symbolPart?.value ?? currency;
};

export const useCurrencySymbol = (currency?: string): string => {
  const { data: marketplaceConfig } = useMarketplaceConfig();

  const determinedCurrency = currency ?? marketplaceConfig?.marketplaceConfig.currency;

  const symbol = useMemo(() => getCurrencySymbol(determinedCurrency), [determinedCurrency]);

  return symbol;
};
